<!-- 
Contents of the DETAILS tab of the notice template page.
-->
<template>
  <div>
    <our-heading
      :breadcrumbs="breadcrumbs"
      :title="title"
      user-guide-topic="levy-collection-setup"
      user-guide-section="notice-templates"
    >
      <template v-slot:navigator>
        <levy-collection-navigator :levy-collection-id="levyCollectionId" />
      </template>
    </our-heading>
    <tabs :levy-collection-id="levyCollectionId" :notice-type="noticeType" :can-edit="canEdit" path="details">
      <notice-template-detail-panel :levy-collection-id="levyCollectionId" :notice-type="noticeType"/>
    </tabs>
  </div>
</template>

<script>
import NoticeTemplateDetailPanel from "@/components/notice-templates/NoticeTemplateDetailPanel.vue";
import LevyCollectionNavigator from "@/components/levy-collections/LevyCollectionNavigator.vue";
import Tabs from "./Tabs.vue";
import noticeTemplateMixins from "./mixins";

export default {
  name: "NoticeTemplateDetails",
  components: { NoticeTemplateDetailPanel, LevyCollectionNavigator, Tabs },
  mixins: [noticeTemplateMixins]
};
</script>
